// extracted by mini-css-extract-plugin
export default {"footer":"search_result_enterprise-module__footer--2CXdD"};